module.exports = __webpack_public_path__ + "static/media/400028_02.e0fa2571.png";